module.exports = __webpack_public_path__ + "static/media/softwareBg2.faa5d77b.jpg";